export default __webpack_public_path__ + "static/clients-0b20d07a0428c8987fe49bc52cb0fe2e.jpg";